var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 19.5,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 19.5,
    stroke: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_647_131869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4462 23.6184C37.0662 23.6184 38.7834 24.51 40.0062 26.052C35.9982 28.2732 36.6498 34.0608 40.6998 35.6076C40.1418 36.8556 39.8754 37.4136 39.1578 38.5188C38.1558 40.0596 36.7458 41.9796 34.995 41.9964C33.441 42.0108 33.0414 40.9728 30.9318 40.9848C28.8222 40.9968 28.3818 42.0144 26.8278 42C25.0782 41.9832 23.7402 40.2504 22.7382 38.7084C19.9374 34.398 19.6446 29.34 21.3726 26.652C22.6002 24.7392 24.5358 23.6196 26.3574 23.6196C28.2114 23.6196 29.3766 24.648 30.9102 24.648C32.3982 24.648 33.303 23.6184 35.4462 23.6184ZM34.9758 18C35.1918 19.458 34.599 20.886 33.8202 21.8964C32.9862 22.9788 31.5498 23.8176 30.1602 23.7744C29.9082 22.3788 30.5586 20.9424 31.3482 19.974C32.2158 18.906 33.7038 18.0888 34.9758 18Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_647_131869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.5 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBtn);
export default __webpack_public_path__ + "static/media/apple-btn.470161cb645f3b64cf9e20dd50a44253.svg";
export { ForwardRef as ReactComponent };